import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { CancelReservingRequestDto, CancelReservingResponseDto } from "./dtos";

export const cancel = async (
  data: CancelReservingRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<CancelReservingResponseDto>> => {
  return await http.post<CancelReservingResponseDto>(
    `/reserved-instances`,
    {
      ...data,
      _method: "delete",
    },
    { cancelToken }
  );
};
